export class Action {
  code: string;

  constructor(obj?: any) {
    Object.assign(this, obj);
  }
}
